import { SystemIcons } from '@almbrand/systemicons';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import styles from './LicensePlateInput.module.scss';

export interface LicensePlateInputProps {
	hasError?: boolean;
	onChange?: (formatted: string, isComplete: boolean) => void;
}

export const LicensePlateInput: React.FC<LicensePlateInputProps> = ({ hasError = false, onChange }) => {
	const [value, setValue] = useState('');
	const [isTouched, setIsTouched] = useState(false);
	const inputRef = useRef<HTMLInputElement>(null);

	const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		const formatted = formatLicensePlate(value);

		setValue(formatted);

		if (onChange) {
			onChange(formatted, isLicensePlateComplete(value));
		}
	};

	const handleContainerClick = () => {
		inputRef.current?.focus();
	};

	const formatLicensePlate = (value: string) => {
		// Remove all non-alphanumeric characters
		const cleaned = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

		// Format: AA 12 35B
		let formatted = '';
		for (let i = 0; i < cleaned.length && i < 7; i++) {
			formatted += cleaned[i];
			if (i === 1 || i === 3 || i === 6) formatted += ' ';
		}
		return formatted.trim();
	};

	const isLicensePlateComplete = (str: string) => {
		const cleaned = str.replace(/[^A-Z0-9]/gi, '').toUpperCase();
		return cleaned.length >= 2;
	};

	return (
		<div
			className={classNames(
				styles.LicensePlateInput,
				hasError && styles['LicensePlateInput--error'],
				isTouched && !isLicensePlateComplete(value) && styles['LicensePlateInput--error']
			)}
			onClick={handleContainerClick}
			onBlur={() => {
				setIsTouched(true);
			}}
		>
			<div className={classNames(styles.LicensePlateInput__icon)}>
				<SystemIcons
					height={16}
					width={16}
					themeName={'Codan-theme'}
					icon={'EU'}
				/>
				<span>DK</span>
			</div>
			<div className={classNames(styles.LicensePlateInput__inputWrapper)}>
				{!value && (
					<div className={classNames(styles.LicensePlateInput__placeholder)}>Tast din nummerplade</div>
				)}

				<div className={classNames(styles.LicensePlateInput__input)}>
					<input
						ref={inputRef}
						name='name'
						type='text'
						onChange={handleOnChange}
						value={value}
						autoComplete='off'
						maxLength={9}
					/>
				</div>
			</div>
		</div>
	);
};
